import { MultiPoint } from '@ikegps/core-measurement';
import type { CollectionModelFieldVector } from '@ikegps/core-shared';
import { T } from '../../../i18n/index';
import type { MithrilVNode } from '../../../mithril';
import { FieldInfo, type FieldStat } from '../../field.info/field.info';
import type { CollectionEditCtrl } from '../collection.view.ctrl';
import type { CollectionFieldView } from './field.view';
import { viewVectorManualEdit } from './vector.manual.field.view';

export const VectorP2PFieldView: CollectionFieldView<CollectionModelFieldVector> = {
	viewInline(field: CollectionModelFieldVector): string {
		return FieldInfo.viewVectorInline(field.value);
	},

	hasDetail(field: CollectionModelFieldVector) {
		return true;
	},

	viewDetail(field: CollectionModelFieldVector): MithrilVNode {
		const collection = field.collection;
		const captures = field.getCaptures();
		const p2pMeasurement = MultiPoint.Points(captures);

		const stats: FieldStat[] = [
			{ name: T.DISTANCE_VERTICAL, value: Math.abs(p2pMeasurement.vertical) },
			{ name: T.DISTANCE_HORIZONTAL, value: p2pMeasurement.horizontal },
		];

		return FieldInfo.viewCaptures(collection, captures, stats);
	},

	viewEdit(field: CollectionModelFieldVector, ctrl: CollectionEditCtrl): MithrilVNode {
		return viewVectorManualEdit(field, ctrl);
	},
};
